import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IUIPage } from "../reducer_interface";

const initialState: IUIPage = {
  title: "Vetic VMS", // default title
};

const uiPageSlice = createSlice({
  name: "ui_page_slice",
  initialState: initialState,
  reducers: {
    setUIPage: (state, action: PayloadAction<IUIPage>) => {
      state.title = action.payload.title;
    },
  },
});

export const { setUIPage } = uiPageSlice.actions;

export default uiPageSlice.reducer;
